import React from "react"
import { useSearchParams } from "react-router-dom"
import { Api } from "../lib/api"
import { Box, Text } from "@chakra-ui/react"
import Link from "./Link"
import { createStripeCustomer } from "../lib/util"
import GradientBox from "./GradientBox"

// After activation, primary CTA links here. Subscription is enforced in AuthRequired.
const POST_ACTIVATION_REDIRECT_URL = "/datasets?product_tour_id=528227"

export default function AccountsActivate(props) {
  const [searchParams] = useSearchParams()
  const { setActivated, setError } = props
  const api = new Api()

  const user_id = searchParams.get("user_id")
  const timestamp = searchParams.get("timestamp")
  const signature = searchParams.get("signature")

  React.useEffect(() => {
    if (!user_id || !timestamp || !signature) {
      setError("Invalid activation link. Please request a new one.")
      return
    }

    const activate = async () => {
      // const resp = await api.OrganizationInvitationAccept(orgId, invId)
      console.log("Sending activation request")
      const resp = await api.accountsVerifyRegistration(
        user_id,
        timestamp,
        signature,
      )
      return resp
    }

    activate()
      .then((resp) => {
        console.log("Activation success")
        setActivated(getSuccessMessage(resp))
        // Create a Stripe customer for the user without waiting for the response.
        createStripeCustomer()
      })
      .catch((error) => error.json().then((r) => setError(r.detail)))
  }, [user_id, timestamp, signature])

  const getSuccessMessage = (resp) => {
    console.log("getSuccessMessage resp =", resp)
    return (
      <Box>
        <p>{resp.detail} </p>
        <p>
          <Text>
            <Link to={POST_ACTIVATION_REDIRECT_URL}>Click here to proceed</Link>
          </Text>
        </p>
      </Box>
    )
  }

  return <GradientBox />
}
